import styled from 'styled-components';
import { rem, themed } from '@/shared/ui/core';

export const MenuWrapper = styled.div`
  position: relative;

  button {
    width: auto;
  }
`;

export const MenuItems = styled.ul`
  background: ${themed('primary.background')};
  border: 1px solid ${themed('common.borderColor')};
  box-shadow: 0 4px 8px -4px rgba(0, 0, 0, 0.25);
  margin: 0;
  min-width: ${rem(90)};
  padding: 0.5rem 0;
  position: absolute;
  left: 0;
  width: 11rem;
  z-index: 2;

  bottom: ${({ $position }) => $position === 'top' ? '1.5rem' : undefined};
  top: ${({ $position }) => $position === 'bottom' ? '1.125rem' : undefined};

  li {
    list-style: none;
    margin: 0;
    width: 100%;
  }
`;

export const MenuItem = styled.a`
  color: ${themed('primary.accent')};
  font-size: ${rem(14)};
  font-weight: 500;
  padding: 0.5rem 0.75rem;
  text-align: left;
  width: 100%;

  align-items: center;
  display: inline-flex;
  justify-content: flex-start;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  span:first-of-type {
    align-items: center;
    display: inline-flex;
    justify-content: center;
    margin-right: 8px;
    width: 18px;

    svg {
      height: 1rem;
      width: auto;
    }
  }
`;
